import { PermissionsEnum } from '@/auth/interfaces';
import { SaveSubcategorias } from '../../shared/saveSubCategoriasProductos';
import { useCheckPermissions } from '@/shared';

export interface CreateSubcategoriasPageInterface {}

const CreateSubcategoriasPage: React.FC<CreateSubcategoriasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_subcategoriaproducto)
  return <SaveSubcategorias titlePage="Crear Subcategorias productos" />;
};

export default CreateSubcategoriasPage;
